import '../libs/mmenu/jquery.mmenu.all';

export default function initializeMenu() {
    initializeMobileMenu();
    initializeServicesMenu();
}

function initializeMobileMenu() {
    let menuContainer = $('.mobile-menu');

    let menu = menuContainer.mmenu({
            extensions: ['theme-dark'],
            keyboardNavigation: {
                enable: true,
                enhance: true
            },
            searchfield: {
                search: false,
                placeholder: menuContainer.data('placeholder'),
            },
            'navbars': [
                {
                    'position': 'top',
                    'content': [
                        'searchfield'
                    ]
                }
            ]
        }, {
            'searchfield': {
                placeholder: menuContainer.data('placeholder'),
                form: {
                    action: '/',
                    method: 'get'
                },
                input: {
                    type: 'text',
                    name: 's',
                    id: 's'
                },
                submit: true,
            }
        }),
        icon = $('.hamburger'),
        api = menu.data('mmenu');

    icon.on('click', function () {
        api.open();
    });
}

function initializeServicesMenu() {
    let items = document.querySelectorAll('.menu__item--opener > .menu__link');

    items.forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
        })
    })
}